module.exports = __webpack_public_path__ + "img/AllegiantStadium-LogoWhite.d88563d5.png";